import { render, staticRenderFns } from "./sync-set.vue?vue&type=template&id=1caebe7d&scoped=true&"
import script from "./sync-set.vue?vue&type=script&lang=js&"
export * from "./sync-set.vue?vue&type=script&lang=js&"
import style0 from "./sync-set.vue?vue&type=style&index=0&id=1caebe7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caebe7d",
  null
  
)

export default component.exports